import React, { ReactNode } from "react";

import EmailEditorsContext, { EmailContextValue } from "./index";

const INITIAL_VALUE: EmailContextValue = {};

const EmailEditorsProvider = ({ children }: { children: ReactNode }) => {
  return (
    <EmailEditorsContext.Provider value={INITIAL_VALUE}>{children}</EmailEditorsContext.Provider>
  );
};

export default EmailEditorsProvider;
